import PartyTarget from "../../../model/character/PartyTarget";
import Statistics from "../../../model/statistics/Statistics";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import TerrainLayerProgress from "./TerrainLayerProgress";

export default class RowContainerLayerProgress extends ParentView {
    /**
     * @param {string} parentId
     * @param {PartyTarget} partyTarget
     * @param {Statistics} statistics
     */
    constructor(parentId, partyTarget, statistics) {
        super(parentId, parentId + '_layer');

        this.addView(new TerrainLayerProgress(this.elementId, this.elementId + '_progress', partyTarget, statistics));
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'top-row-two');

        super.initializeView();
    }
}